import gql from 'graphql-tag';

const GET_AUTO_START_TIMER_INFO = gql`
  query {
    getAutoStartTimerInfo {
      defaultServiceItem {
        itemId
        name
      }
      defaultServiceCatalogItem {
        itemId
        name
      }
      autoStartTimer
    }
  }
`;

export { GET_AUTO_START_TIMER_INFO };
